module.exports = __webpack_public_path__ + "img/bottomViewImg.0fc80a01.png";